import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import getReceiversNotificationSetting from 'services/settings/getReceiversNotificationSetting'
import updateNotificationSettings from 'services/settings/updateNotificationSettings'
import { NotificationSettingsData } from '../AlertType/AlertType'

export function useReceiversNotificationSettingsQuery() {
  return useQuery<Map<string, NotificationSettingsData>>({
    queryKey: ['receiversSettings'],
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    staleTime: Infinity,
    queryFn: getReceiversNotificationSetting,
  })
}

export function useUpsertNotificationSettings() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: Map<string, NotificationSettingsData>) =>
      updateNotificationSettings(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['contactSettings'],
      })
      queryClient.invalidateQueries({
        queryKey: ['receiversSettings'],
      })
    },
  })
}